import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/customer/home/TestimonialSection.css';

const TestimonialSection = () => {
  const navigate = useNavigate(); // ✅ FIX

  return (
    <section className="testimonial-section">
      <Container fluid>
        <Row className="align-items-center testimonial-row">
          
          {/* LEFT Side - Image */}
          <Col lg={6} md={12} className="testimonial-image-col">
            <div className="testimonial-image-container">
              <img 
                src="https://i.pinimg.com/736x/46/23/3c/46233c5bb5c9f0f868659b216ea071a2.jpg" 
                alt="Wedding Couple"
                className="couple-wedding-photo"
              />
            </div>
          </Col>

          {/* RIGHT Side - Content */}
          <Col lg={6} md={12} className="testimonial-content-col">
            <div className="testimonial-content">
              
              {/* Heading FIXED */}
              <h2 className="testimonial-heading">
                Marry Jain & Jamie Foster
              </h2>

              {/* Description */}
              <p className="testimonial-description">
              Love Stories We Helped Create.
              </p>

              {/* Button with Navigation */}
              <button 
                      className="btn-see-story"
                onClick={() => {
               document.getElementById("video-section")?.scrollIntoView({ behavior: "smooth" });
                          }}
>
           ▶ See the Story
    </button>

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default TestimonialSection;